import { proposalsService, briefingsService } from '../services/api';
import { ImpactoDaExclusao } from './crm';

/**
 * P2 (11/10/2026): lê o que a exclusão do lead atinge, para o confirm dizer. As propostas sem leitura viram `null` (e a
 * exclusão é recusada); o briefing sem leitura vira `null` (o confirm diz "se houver"). Briefing com `id` null = nunca
 * gravado.
 */
export async function lerImpactoDaExclusao(leadId: number): Promise<ImpactoDaExclusao> {
  const [propostas, briefing] = await Promise.all([
    proposalsService.getByLead(leadId).then((r: any) => (Array.isArray(r) ? r : []), () => null),
    briefingsService.get(leadId).then((b) => !!b?.id, () => null),
  ]);
  return { propostas, temBriefing: briefing };
}
